export default __webpack_public_path__ + "static/media/5193.dc6e23c3.png";